import { Alert, AlertDescription } from "../../../../components/ui/alert";
import { Card, CardContent } from "../../../../components/ui/card";
import { Skeleton } from "../../../../components/ui/skeleton";
import { useCheckoutList } from "../../hooks/useCheckoutList";
import { CheckoutOperationCard } from "../checkout-operation-card";

interface CheckoutListViewerProps {
  ops?: string;
  dbName: string;
}

export function CheckoutListViewer({ ops, dbName }: CheckoutListViewerProps) {
  const {
    data = [],
    isPending,
    isError,
    refetch,
  } = useCheckoutList(ops || "", dbName, !!ops);

  if (!ops) {
    return (
      <Alert>
        <AlertDescription>
          Selecione uma operação no menu para visualizar os checkouts
        </AlertDescription>
      </Alert>
    );
  }

  if (isPending) {
    return (
      <Card>
        <CardContent className="py-12">
          <div className="text-center space-y-4">
            <div className="flex justify-center">
              <Skeleton className="h-12 w-12 rounded-full" />
            </div>
            <Skeleton className="h-4 w-48 mx-auto" />
          </div>
        </CardContent>
      </Card>
    );
  }

  if (isError) {
    return (
      <Alert variant="destructive">
        <AlertDescription>
          Não foi possível carregar os checkouts. Tente novamente em instantes.
        </AlertDescription>
      </Alert>
    );
  }

  if (data.length === 0) {
    return (
      <Alert>
        <AlertDescription>
          Não há checkouts para serem finalizados nos últimos 20 dias
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-semibold uppercase mb-1">{ops}</h2>
        <p className="text-sm text-muted-foreground">
          {data.length} checkout{data.length !== 1 ? "s" : ""} pendente
          {data.length !== 1 ? "s" : ""}
        </p>
      </div>

      {data.map((item, index) => (
        <CheckoutOperationCard
          key={`${item.date_to_checkout}-${item.ops}-${index}`}
          item={item}
          dbName={dbName}
          onRefresh={() => refetch()}
        />
      ))}
    </div>
  );
}
